<template>
  <section class="shr-placeholder-loader">
    <div class="loader-card" :class="customClass" :style="{width, height, margin}"></div>
  </section>
</template>

<script lang="ts">
export default {
  name: 'PlaceHolderLoader',
  props: {
    height: {
      type: String,
      default: '65px',
    },
    width: {
      type: String,
      default: '100%',
    },
    margin: {
      type: String,
      default: '0px'
    },
    customClass: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.shr-placeholder-loader{
  background-color:transparent;
  direction:ltr;
  position:relative;
  overflow:hidden;

  & *, &:after, &:before {
    box-sizing: border-box
  }
  &:before{
    -webkit-animation:loader-animation .8s linear infinite;
    animation:loader-animation .8s linear infinite;
    background:linear-gradient(90deg,hsla(0,0%,100%,0) 46%,hsla(0,0%,100%,.35) 50%,hsla(0,0%,100%,0) 54%) 50% 50%;
    bottom:0;
    content:" ";
    left:50%;
    margin-left:-250%;
    pointer-events:none;
    position:absolute;
    right:0;
    top:0;
    width:500%;
    z-index:1
  }

  .loader-card{
    background-color:#ced4da;
  }
  @-webkit-keyframes loader-animation{
    0%{
      transform:translate3d(-30%,0,0)
    }
  }
  to{
    transform:translate3d(30%,0,0)
  }
}
@keyframes loader-animation{
  0%{
    transform:translate3d(-30%,0,0)
  }
  to{
    transform:translate3d(30%,0,0)
  }
}
</style>
